import { IsBoolean } from 'class-validator';

export class UpdateBasicInformationIsLegalDto {
  @IsBoolean()
  isLegal!: boolean;
}
